import { useState, useEffect } from "react";
import { Users, Shield, User } from "lucide-react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../../components/ui/select";
import { toast } from "sonner";
import { authFetch } from "../../services/authService";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AdminUsers({ user }) {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = async () => {
    try {
      const response = await authFetch(`${API}/admin/users`, { });
      if (response.ok) {
        setUsers(await response.json());
      }
    } catch (error) {
      toast.error("Errore nel caricamento utenti");
    } finally {
      setLoading(false);
    }
  };

  const handleRoleChange = async (userId, role) => {
    try {
      const response = await authFetch(`${API}/admin/users/${userId}/role?role=${role}`, {
        method: "PATCH"
      });

      if (response.ok) {
        toast.success("Ruolo aggiornato");
        fetchUsers();
      }
    } catch (error) {
      toast.error("Errore nell'aggiornamento");
    }
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center h-96">
        <div className="spinner"></div>
      </div>
    );
  }

  return (
    <div data-testid="admin-users-page" className="space-y-6">
      {/* Header */}
      <div className="page-header">
        <h1 className="page-title">Gestione Utenti</h1>
        <div className="text-zinc-500">{users.length} utenti registrati</div>
      </div>

      {/* Users Table */}
      <div className="overflow-x-auto">
        <table className="w-full data-table">
          <thead>
            <tr>
              <th>Utente</th>
              <th>Email</th>
              <th>Punti</th>
              <th>Data Registrazione</th>
              <th>Ruolo</th>
            </tr>
          </thead>
          <tbody>
            {users.map((u) => (
              <tr key={u.user_id}>
                <td>
                  <div className="flex items-center gap-3">
                    {u.picture ? (
                      <img src={u.picture} alt={u.name} className="w-10 h-10 rounded-sm" />
                    ) : (
                      <div className="w-10 h-10 bg-zinc-800 rounded-sm flex items-center justify-center">
                        <User className="w-5 h-5 text-zinc-600" />
                      </div>
                    )}
                    <span className="text-white">{u.name}</span>
                  </div>
                </td>
                <td className="text-zinc-400">{u.email}</td>
                <td className="font-['JetBrains_Mono'] text-primary">{u.points}</td>
                <td className="font-['JetBrains_Mono'] text-zinc-500">
                  {u.created_at ? new Date(u.created_at).toLocaleDateString("it-IT") : "-"}
                </td>
                <td>
                  <Select
                    value={u.role}
                    onValueChange={(value) => handleRoleChange(u.user_id, value)}
                    disabled={u.user_id === user.user_id}
                  >
                    <SelectTrigger className="w-32 bg-zinc-950 border-zinc-800">
                      <SelectValue />
                    </SelectTrigger>
                    <SelectContent className="bg-zinc-900 border-zinc-800">
                      <SelectItem value="user">
                        <div className="flex items-center gap-2">
                          <User className="w-4 h-4" />
                          Utente
                        </div>
                      </SelectItem>
                      <SelectItem value="admin">
                        <div className="flex items-center gap-2">
                          <Shield className="w-4 h-4" />
                          Admin
                        </div>
                      </SelectItem>
                    </SelectContent>
                  </Select>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
